import { render, staticRenderFns } from "./businessUser.vue?vue&type=template&id=e720f918&scoped=true&"
import script from "./businessUser.vue?vue&type=script&lang=js&"
export * from "./businessUser.vue?vue&type=script&lang=js&"
import style0 from "./businessUser.vue?vue&type=style&index=0&id=e720f918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e720f918",
  null
  
)

export default component.exports